import React from 'react';
import {
  Box,
  Card,
  CardContent,
  Divider,
  Typography,
  makeStyles
} from '@material-ui/core';


const useStyles = makeStyles((theme) => ({
  card: {
    overflow: 'visible',
    display: 'flex',
    position: 'relative',
    '& > *': {
      flexGrow: 1,
      flexBasis: '50%',
      width: '50%'
    }
  },
  content: {
    padding: theme.spacing(4, 4, 3, 4)
  },
  footer: {
    display: 'flex',
    justifyContent: 'space-between',
  }
}));

type Props = {
    title?: string;
    subtitle?: string;
    children?: any;
    footer?: any;
};

function BaseCard(props: Props) {
  const classes = useStyles();
  const {
    title,
    subtitle,
    children,
    footer
  } = props;

  return (
    <Card className={classes.card}>
      <CardContent className={classes.content}>
        <Box pb={2}>
          <Typography
            variant="h2"
            color="textPrimary"
          >
            {title}
          </Typography>
          {
            subtitle && (
              <Typography
                variant="subtitle1"
                color="textSecondary"
              >
                {subtitle}
              </Typography>
            )
          }
        </Box>
        {children}
        <Box my={2}>
          <Divider />
        </Box>
        {footer}
      </CardContent>
    </Card>
  );
}

export default BaseCard;
